import {
  mutationTypes,
  actionTypes,
} from '@/store/types';
import xhr from '@/modules/xhr';
import { log } from '@/modules/errors';

const state = {
  dealers: null,
  dealersToMark: [],
  dealersToDraw: [],
  focusedDealer: null,
};

const getters = {
  name: state => state.dealers && state.dealers[0].DealerInfo.distributor,
  isDealerDrawn: state => dealerId => state.dealersToDraw.indexOf(dealerId) !== -1,
  regionByDealerId: state => (dealerId, regionIndex) => {
    const dealerData = state.dealers.find(dealer => dealer.DealerInfo.company_id === dealerId);

    if (!dealerData) return undefined;

    return dealerData.Regions[regionIndex];
  },
};

const actions = {
  async [actionTypes.distributor.getDistributor]({ commit }) {
    try {
      const { data } = await xhr.get(`${process.env.API_BASEURL}/distributors/serviceareas`);

      commit(mutationTypes.distributor.setDealerList, data);
    } catch (err) {
      log(err);
      throw err;
    }
  },
};

const mutations = {
  [mutationTypes.distributor.setDealerList](state, payload) {
    state.dealers = payload;
  },

  [mutationTypes.distributor.setDealersToDraw](state, payload) {
    state.dealersToDraw = payload;
  },

  [mutationTypes.distributor.addDealerToDraw](state, payload) {
    state.dealersToDraw.push(payload.dealerId);
  },

  [mutationTypes.distributor.removeDealerToDraw](state, payload) {
    const dealerIdIndex = state.dealersToDraw.indexOf(payload.dealerId);

    if (dealerIdIndex !== -1) {
      state.dealersToDraw.splice(dealerIdIndex, 1);
    }
  },

  [mutationTypes.distributor.removeDefaultRegion](state, payload) {
    const dealerItemIndex = state.dealers.findIndex(dealer => (
      dealer.DealerInfo.company_id === payload.dealerId
    ));

    if (dealerItemIndex === -1) return;

    const dealerItem = state.dealers[dealerItemIndex];

    state.dealers.splice(dealerItemIndex, 1, {
      ...dealerItem,
      Regions: [],
    });
  },

  [mutationTypes.distributor.addRegionToDealer](state, payload) {
    const dealerItemIndex = state.dealers.findIndex(dealer => (
      dealer.DealerInfo.company_id === payload.dealerId
    ));

    if (dealerItemIndex === -1) return;

    const dealerItem = state.dealers[dealerItemIndex];

    state.dealers.splice(dealerItemIndex, 1, {
      ...dealerItem,
      Regions: [
        ...dealerItem.Regions,
        payload.region,
      ],
    });
  },

  [mutationTypes.distributor.editRegionOnDealer](state, payload) {
    const dealerItemIndex = state.dealers.findIndex(dealer => (
      dealer.DealerInfo.company_id === payload.dealerId
    ));

    if (dealerItemIndex === -1) return;

    const dealerItem = state.dealers[dealerItemIndex];
    const newRegionsList = [...dealerItem.Regions];

    newRegionsList.splice(payload.regionIndex, 1, payload.region);

    state.dealers.splice(dealerItemIndex, 1, {
      ...dealerItem,
      Regions: newRegionsList,
    });
  },

  [mutationTypes.distributor.removeRegionFromDealer](state, payload) {
    const dealerItemIndex = state.dealers.findIndex(dealer => (
      dealer.DealerInfo.company_id === payload.dealerId
    ));

    if (dealerItemIndex === -1) return;

    const dealerItem = state.dealers[dealerItemIndex];
    const newRegionsList = [...dealerItem.Regions];

    newRegionsList.splice(payload.regionIndex, 1);

    state.dealers.splice(dealerItemIndex, 1, {
      ...dealerItem,
      Regions: newRegionsList,
    });
  },

  [mutationTypes.distributor.setDealersToMark](state, payload) {
    state.dealersToMark = payload;
  },

  [mutationTypes.distributor.addDealerToMark](state, payload) {
    state.dealersToMark.push(payload.dealerId);
  },

  [mutationTypes.distributor.removeDealerToMark](state, payload) {
    const dealerIdIndex = state.dealersToMark.findIndex(payload.dealerId);

    if (dealerIdIndex !== -1) {
      state.dealersToMark.splice(dealerIdIndex, 1);
    }
  },

  [mutationTypes.distributor.setFocusedDealer](state, payload) {
    state.focusedDealer = payload.dealerId;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/distributor.js